import type React from 'react'

// Màu sao vàng đánh giá mang nghĩa cố định, không đổi theo theme
// ds-guard-ignore: sao vàng đánh giá
const STAR_GOLD = '#FADB14'
// ds-guard-ignore: sao vàng đánh giá (sáng)
const STAR_GOLD_LIGHT = '#FFF1B8'
// ds-guard-ignore: sao vàng đánh giá (cam viền)
const STAR_ORANGE = '#FA8C16'
// ds-guard-ignore: đổ bóng sao, đen cố định
const STAR_SHADOW = '#000000'

export interface StarIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number
  filled?: boolean
  disabled?: boolean
  activeColor?: string
  inactiveColor?: string
}

export const StarIcon: React.FC<StarIconProps> = ({
  size = 26,
  filled = true,
  disabled = false,
  activeColor = STAR_GOLD,
  inactiveColor = 'var(--vbdt-color-border-subtle)',
  style,
  ...props
}) => {
  const fillColor = disabled
    ? filled
      ? 'var(--vbdt-color-border-default)'
      : 'var(--vbdt-color-bg-sunken)'
    : filled
      ? activeColor
      : inactiveColor
  const strokeColor = disabled
    ? filled
      ? 'var(--vbdt-color-border-strong)'
      : 'var(--vbdt-color-border-default)'
    : filled
      ? STAR_ORANGE
      : 'var(--vbdt-color-border-default)'

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transition: 'transform 0.15s ease, fill 0.15s ease',
        cursor: disabled ? 'not-allowed' : 'pointer',
        verticalAlign: 'middle',
        ...style,
      }}
      {...props}
    >
      <defs>
        <linearGradient id="goldStarGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={STAR_GOLD_LIGHT} />
          <stop offset="35%" stopColor={STAR_GOLD} />
          <stop offset="100%" stopColor={STAR_ORANGE} />
        </linearGradient>
        <filter id="goldStarShadow" x="-15%" y="-15%" width="130%" height="130%">
          <feDropShadow
            dx="0"
            dy="1"
            stdDeviation="0.8"
            floodColor={STAR_SHADOW}
            floodOpacity="0.2"
          />
        </filter>
      </defs>
      <path
        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        fill={filled && !disabled ? 'url(#goldStarGradient)' : fillColor}
        stroke={strokeColor}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={filled && !disabled ? 'url(#goldStarShadow)' : undefined}
      />
    </svg>
  )
}

export default StarIcon
